import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation WaiveServiceFeesByTenant($businessId: ID!, $waive: Boolean!) {
    waiveServiceFeesByTenant(businessId: $businessId, waive: $waive)
  }
`
export default mutation
